/**
 * Generated by orval 🍺
 * Do not edit manually.
 * IST.Connect | v1
 * REST API backing the IST Connect web frontend. Provides endpoints to manage plugin configurations and inspect task execution results, logs, and dashboard data.
 * OpenAPI spec version: 1.0.0
 */
import type {
	CreateUntisXschoolScheduleConfigRequest,
	Errors,
	GetUntisXschoolScheduleConfigsParams,
	GetUntisXschoolSubstitutionConfigsParams,
	UntisXschoolScheduleConfig,
	UntisXschoolScheduleConfigCreatedResponse,
	UntisXschoolScheduleConfigPage,
	UntisXschoolSubstitutionConfig,
	UntisXschoolSubstitutionConfigCreatedResponse,
	UntisXschoolSubstitutionConfigPage,
	UpdateUntisXschoolScheduleConfigRequest,
} from "../model";

import { customFetch } from "../../customFetcher";

export const getCreateUntisXschoolScheduleConfigUrl = () => {
	return `/istconnect-service-api/untis-xschool-schedule-configs`;
};

/**
 * @summary Creates a new plugin config
 */
export const createUntisXschoolScheduleConfig = async (
	createUntisXschoolScheduleConfigRequest: CreateUntisXschoolScheduleConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolScheduleConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisXschoolScheduleConfigCreatedResponse>(getCreateUntisXschoolScheduleConfigUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(createUntisXschoolScheduleConfigRequest),
	});
};

export const getGetUntisXschoolScheduleConfigsUrl = (params?: GetUntisXschoolScheduleConfigsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/untis-xschool-schedule-configs?${stringifiedParams}`
		: `/istconnect-service-api/untis-xschool-schedule-configs`;
};

/**
 * @summary Get all UntisXschool schedule configurations
 */
export const getUntisXschoolScheduleConfigs = async (
	params?: GetUntisXschoolScheduleConfigsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolScheduleConfigPage> => {
	return customFetch<UntisXschoolScheduleConfigPage>(getGetUntisXschoolScheduleConfigsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getCreateUntisXschoolSubstitutionConfigUrl = () => {
	return `/istconnect-service-api/untis-xschool-substitution-configs`;
};

/**
 * @summary Creates a new plugin config
 */
export const createUntisXschoolSubstitutionConfig = async (
	createUntisXschoolScheduleConfigRequest: CreateUntisXschoolScheduleConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolSubstitutionConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisXschoolSubstitutionConfigCreatedResponse>(getCreateUntisXschoolSubstitutionConfigUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(createUntisXschoolScheduleConfigRequest),
	});
};

export const getGetUntisXschoolSubstitutionConfigsUrl = (params?: GetUntisXschoolSubstitutionConfigsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/istconnect-service-api/untis-xschool-substitution-configs?${stringifiedParams}`
		: `/istconnect-service-api/untis-xschool-substitution-configs`;
};

/**
 * @summary Get all UntisXschool substitution configurations
 */
export const getUntisXschoolSubstitutionConfigs = async (
	params?: GetUntisXschoolSubstitutionConfigsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolSubstitutionConfigPage> => {
	return customFetch<UntisXschoolSubstitutionConfigPage>(getGetUntisXschoolSubstitutionConfigsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getDeleteUntisXschoolScheduleConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-schedule-configs/${id}`;
};

/**
 * @summary Deletes a untis xschool schedule plugin config
 */
export const deleteUntisXschoolScheduleConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Errors> => {
	return customFetch<Errors>(getDeleteUntisXschoolScheduleConfigUrl(id), {
		...options,
		method: "DELETE",
	});
};

export const getGetUntisXschoolScheduleConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-schedule-configs/${id}`;
};

/**
 * @summary Get a untis xschool schedule plugin config
 */
export const getUntisXschoolScheduleConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UntisXschoolScheduleConfig> => {
	return customFetch<UntisXschoolScheduleConfig>(getGetUntisXschoolScheduleConfigUrl(id), {
		...options,
		method: "GET",
	});
};

export const getUpdateUntisXschoolScheduleConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-schedule-configs/${id}`;
};

/**
 * @summary Updates a untis xschool schedule plugin config
 */
export const updateUntisXschoolScheduleConfig = async (
	id: string,
	updateUntisXschoolScheduleConfigRequest: UpdateUntisXschoolScheduleConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolScheduleConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisXschoolScheduleConfigCreatedResponse>(getUpdateUntisXschoolScheduleConfigUrl(id), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(updateUntisXschoolScheduleConfigRequest),
	});
};

export const getDeleteUntisXschoolSubstitutionConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-substitution-configs/${id}`;
};

/**
 * @summary Deletes a untis xschool substitution plugin config
 */
export const deleteUntisXschoolSubstitutionConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<Errors> => {
	return customFetch<Errors>(getDeleteUntisXschoolSubstitutionConfigUrl(id), {
		...options,
		method: "DELETE",
	});
};

export const getGetUntisXschoolSubstitutionConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-substitution-configs/${id}`;
};

/**
 * @summary Get a untis xschool substitution plugin config
 */
export const getUntisXschoolSubstitutionConfig = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<UntisXschoolSubstitutionConfig> => {
	return customFetch<UntisXschoolSubstitutionConfig>(getGetUntisXschoolSubstitutionConfigUrl(id), {
		...options,
		method: "GET",
	});
};

export const getUpdateUntisXschoolSubstitutionConfigUrl = (id: string) => {
	return `/istconnect-service-api/untis-xschool-substitution-configs/${id}`;
};

/**
 * @summary Updates a untis xschool substitution plugin config
 */
export const updateUntisXschoolSubstitutionConfig = async (
	id: string,
	updateUntisXschoolScheduleConfigRequest: UpdateUntisXschoolScheduleConfigRequest,
	options?: Parameters<typeof customFetch>[1],
): Promise<UntisXschoolSubstitutionConfigCreatedResponse> => {
	const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]));
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<UntisXschoolSubstitutionConfigCreatedResponse>(getUpdateUntisXschoolSubstitutionConfigUrl(id), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json-patch+json", ...getHeaders(options?.headers) },
		body: JSON.stringify(updateUntisXschoolScheduleConfigRequest),
	});
};
